import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { CourseService } from "@scaffold/services/course.service";
import { ViewUpdateService } from "@scaffold/services/view-update.service";
import { trigger, transition, style, animate } from "@angular/animations";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { RenderedService } from "../../rendered.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslationService } from "@services/translation.service";

@Component({
  selector: "app-listindex",
  templateUrl: "./listindex.component.html",
  styleUrls: ["../../rendered.component.scss", "./listindex.component.scss"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 })),
      ]),
      transition(":leave", [
        // :leave is alias to '* => void'
        animate(500, style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ListindexComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  loading;
  view = [];
  rootItem;
  item_data = [];
  active = -1;
  displayItem;
  display_view = [];
  display_item_data;
  constructor(
    private courseService: CourseService,
    private viewUpdate: ViewUpdateService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public translationService:TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    console.log("INIT CARD LIST");
    console.log(this);
    //listen for changes to a list
    this.viewUpdate.registerListUpdate().subscribe((data) => {
      console.log("list index");
      console.log(data);
      var isType = false;
      //check if the list update was for the list type
      if (data && data.list_type === "list") {
        //check if the list updated contains item of this type
        if (this.item.list_view.push) {
          this.item.list_view.forEach((type, _i) => {
            if (type.name == data.type) {
              isType = true;
            }
          });
        } else {
          if (this.item.list_view == data.type) {
            isType = true;
          }
        }
        if (isType) {
          if (data.removed) {
            if (this.item && this.item.list_view) {
              var found = -1;
              this.view.forEach((v, i) => {
                if (v.id == data.removed) {
                  found = i;
                }
              });
              if (found >= 0) {
                this.view.splice(found, 1);
                this.getListItems();
              } else if (this.info.children) {
                this.courseService
                  .get(
                    this.info.type +
                      "/" +
                      this.info.id +
                      "/" +
                      this.item.type +
                      "/" +
                      this.item.id +
                      "?mode=" +
                      (this.item.list_mode || "list")
                  )
                  .subscribe((updated) => (this.info.children = updated));
              }
            }
          } else if (data.added) {
            if (this.info.id === data.parent_id) this.getListItems();
          } else {
            console.log("Preview Push");
            this.view.push(data.placeholder);
            this.cdr.markForCheck();
            console.log(this.view);
          }
        }
      }
    });
    this.getListItems();

    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((_e) => {
        this.cdr.detectChanges();
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getTitle(label){
    return this.translationService.getTranslationKey('create') + " " + label
  }
  
  selectItem(index, preventCancel, fromDisplay?) {
    console.log(this.active);
    //this.display_view = undefined;
    if (this.active === index && !preventCancel) {
      this.active = -1;
      this.view.forEach((v) => (v.active_card = undefined));
      if (this.displayItem) this.displayItem.isActiveList = false;
      this.displayItem = null;
      this.display_view[index] = null;
      this.cdr.markForCheck();
    } else {
      this.view.forEach((v, i) => {
        if (i !== index) v.active_card = false;
      });
      this.active = index;
      this.view[index].active_card = true;
    }
    if (!fromDisplay) {
      this.clearDisplayContent();
    }
    console.log(this.active);
    console.log(this.view[index]);

    this.triggerUpdate("card change");
    setTimeout(() => {
      this.triggerUpdate("card change");
    }, 320);
  }
  clearDisplayContent(active?) {
    if (this.displayItem) this.displayItem.isActiveList = false;
    this.displayItem = null;
    this.display_view.forEach((v, i) => {
      if (!active || active.index != i) this.display_view[i] = null;
    });
  }
  getListItems(isInitial?) {
    var query = "";
    let base = {};
    console.log(this.item.list_view);
    if (!this.item.list_view[0]) {
      return null;
    }

    if (this.item.list_view.push) {
      base = this.item.list_view[0].name;

      if (this.item.list_view.length > 1) {
        query = "&additional=";
        this.item.list_view.forEach((v, i) => {
          if (i > 0) {
            query += v.name;
            if (i < this.item.list_view.length - 1) {
              query += ",";
            }
          }
        });
      }
    } else {
      base = this.item.list_view;
    }

    if (this.item.param && this.item.req_value) {
      query +=
        "&searchParam=" +
        this.item.req_value +
        "&searchTerm=" +
        this.item.param;
    }

    var url = "courses/" + this.courseService.id + "/" + base;

    if (this.info) {
      if (this.info.type && this.info.id) {
        url = this.info.type + "/" + this.info.id + "/" + base;
      } else {
        url = "" + base;
      }
    }

    console.log(this.item);
    url += "?mode=" + (this.item.list_mode || "list") + query;

    if (this.item.nested) {
      url += "&recursive=true";
    }
    this.loading = true;
    this.courseService
      .get(url)
      .subscribe((co) => this.processItems(co, isInitial));

    return url;
  }

  processItems(co, initial?) {
    this.view = [];
    var existing = [];
    this.rootItem = this;
    var list_items = {};
    var allList = [];

    if (co && co.push) {
      co.listItems = co;
    }
    if (co && co.id) {
      co = { listItems: [co] };
    }
    //   list_items[this.courseService.id] = {};
    if (co && co.listItems) {
      if (co.listItems.push) {
        co.listItems.sort(
          (a, b) => parseInt(a.position) - parseInt(b.position)
        );

        co.listItems.forEach((v, _i) => {
          if (v) {
            if (initial) {
              v.rootItem = this;
              v.rootView = this.item;
            } else {
              v.rootItem = this.info.rootItem;
              v.rootView = this.info.rootView;
            }
            list_items[v.id] = v;
          }
        });
        co.listItems.forEach((v, _i) => {
          if (v && existing.indexOf(v.id) < 0) {
            existing.push(v.id);
            if (list_items[v.parent_id]) {
              /*  if (list_items[v.parent_id].type === 'moduleitems') {
                  list_items[v.parent_id].children = v;
              } else {*/
              if (!list_items[v.parent_id].childview) {
                list_items[v.parent_id].childview = [];
              }
              v.parent = list_items[v.parent_id];

              list_items[v.parent_id].childview.push(v);
              if (this.item.root_list) {
                allList.push(v);
              }
              // }
            } else {
              v.parent = this.info;
              if (!this.item.root_list) {
                this.view.push(v);
                this.item_data.push({});
              } else {
                allList.push(v);
              }
            }
          }
        });
        if (this.item.root_list) {
          this.view = allList.sort((a, b) => {
            var order = parseInt(a.position) - parseInt(b.position);
            if (order === 0) {
              if (a.id === b.parent_id) order = -1;
              if (b.id === a.parent_id) order = 1;
            }
            return order;
          });
        }
        //   console.log(this.view);
      } else {
        this.item_data.push({});
        this.view = [co.listItems];
      }
    } else {
      this.view = [];
    }
    this.loading = false;
    this.triggerUpdate();
  }

  createData() {
    let adv_sort;
    if (this.item.adv_sort && this.item.adv_sort.length > 0) {
      adv_sort = this.item.adv_sort
        .map((i, _ind) => {
          if (i.param && i.value) return i.param + ":" + i.value;
          else return false;
        })
        .join(",");
    }
    this.displayItem.createData.call(this.displayItem, "adv_sort=" + adv_sort);
  }
  trackByFn(index, item) {
    return item.id; // unique id corresponding to the item
  }
  triggerUpdate(e?) {
    // console.log(e);
    try {
      this.viewUpdate.triggerChangePropagation(e);
    } catch (e) {
      //  console.log(e)
    }
  }
}

/*
{
    "aliceblue": "#f0f8ff",
    "antiquewhite": "#faebd7",
    "aqua": "#00ffff",
    "aquamarine": "#7fffd4",
    "azure": "#f0ffff",
    "beige": "#f5f5dc",
    "bisque": "#ffe4c4",
    "black": "#000000",
    "blanchedalmond": "#ffebcd",
    "blue": "#0000ff",
    "blueviolet": "#8a2be2",
    "brown": "#a52a2a",
    "burlywood": "#deb887",
    "cadetblue": "#5f9ea0",
    "chartreuse": "#7fff00",
    "chocolate": "#d2691e",
    "coral": "#ff7f50",
    "cornflowerblue": "#6495ed",
    "cornsilk": "#fff8dc",
    "crimson": "#dc143c",
    "cyan": "#00ffff",
    "darkblue": "#00008b",
    "darkcyan": "#008b8b",
    "darkgoldenrod": "#b8860b",
    "darkgray": "#a9a9a9",
    "darkgreen": "#006400",
    "darkgrey": "#a9a9a9",
    "darkkhaki": "#bdb76b",
    "darkmagenta": "#8b008b",
    "darkolivegreen": "#556b2f",
    "darkorange": "#ff8c00",
    "darkorchid": "#9932cc",
    "darkred": "#8b0000",
    "darksalmon": "#e9967a",
    "darkseagreen": "#8fbc8f",
    "darkslateblue": "#483d8b",
    "darkslategray": "#2f4f4f",
    "darkslategrey": "#2f4f4f",
    "darkturquoise": "#00ced1",
    "darkviolet": "#9400d3",
    "deeppink": "#ff1493",
    "deepskyblue": "#00bfff",
    "dimgray": "#696969",
    "dimgrey": "#696969",
    "dodgerblue": "#1e90ff",
    "firebrick": "#b22222",
    "floralwhite": "#fffaf0",
    "forestgreen": "#228b22",
    "fuchsia": "#ff00ff",
    "gainsboro": "#dcdcdc",
    "ghostwhite": "#f8f8ff",
    "goldenrod": "#daa520",
    "gold": "#ffd700",
    "gray": "#808080",
    "green": "#008000",
    "greenyellow": "#adff2f",
    "grey": "#808080",
    "honeydew": "#f0fff0",
    "hotpink": "#ff69b4",
    "indianred": "#cd5c5c",
    "indigo": "#4b0082",
    "ivory": "#fffff0",
    "khaki": "#f0e68c",
    "lavenderblush": "#fff0f5",
    "lavender": "#e6e6fa",
    "lawngreen": "#7cfc00",
    "lemonchiffon": "#fffacd",
    "lightblue": "#add8e6",
    "lightcoral": "#f08080",
    "lightcyan": "#e0ffff",
    "lightgoldenrodyellow": "#fafad2",
    "lightgray": "#d3d3d3",
    "lightgreen": "#90ee90",
    "lightgrey": "#d3d3d3",
    "lightpink": "#ffb6c1",
    "lightsalmon": "#ffa07a",
    "lightseagreen": "#20b2aa",
    "lightskyblue": "#87cefa",
    "lightslategray": "#778899",
    "lightslategrey": "#778899",
    "lightsteelblue": "#b0c4de",
    "lightyellow": "#ffffe0",
    "lime": "#00ff00",
    "limegreen": "#32cd32",
    "linen": "#faf0e6",
    "magenta": "#ff00ff",
    "maroon": "#800000",
    "mediumaquamarine": "#66cdaa",
    "mediumblue": "#0000cd",
    "mediumorchid": "#ba55d3",
    "mediumpurple": "#9370db",
    "mediumseagreen": "#3cb371",
    "mediumslateblue": "#7b68ee",
    "mediumspringgreen": "#00fa9a",
    "mediumturquoise": "#48d1cc",
    "mediumvioletred": "#c71585",
    "midnightblue": "#191970",
    "mintcream": "#f5fffa",
    "mistyrose": "#ffe4e1",
    "moccasin": "#ffe4b5",
    "navajowhite": "#ffdead",
    "navy": "#000080",
    "oldlace": "#fdf5e6",
    "olive": "#808000",
    "olivedrab": "#6b8e23",
    "orange": "#ffa500",
    "orangered": "#ff4500",
    "orchid": "#da70d6",
    "palegoldenrod": "#eee8aa",
    "palegreen": "#98fb98",
    "paleturquoise": "#afeeee",
    "palevioletred": "#db7093",
    "papayawhip": "#ffefd5",
    "peachpuff": "#ffdab9",
    "peru": "#cd853f",
    "pink": "#ffc0cb",
    "plum": "#dda0dd",
    "powderblue": "#b0e0e6",
    "purple": "#800080",
    "rebeccapurple": "#663399",
    "red": "#ff0000",
    "rosybrown": "#bc8f8f",
    "royalblue": "#4169e1",
    "saddlebrown": "#8b4513",
    "salmon": "#fa8072",
    "sandybrown": "#f4a460",
    "seagreen": "#2e8b57",
    "seashell": "#fff5ee",
    "sienna": "#a0522d",
    "silver": "#c0c0c0",
    "skyblue": "#87ceeb",
    "slateblue": "#6a5acd",
    "slategray": "#708090",
    "slategrey": "#708090",
    "snow": "#fffafa",
    "springgreen": "#00ff7f",
    "steelblue": "#4682b4",
    "tan": "#d2b48c",
    "teal": "#008080",
    "thistle": "#d8bfd8",
    "tomato": "#ff6347",
    "turquoise": "#40e0d0",
    "violet": "#ee82ee",
    "wheat": "#f5deb3",
    "white": "#ffffff",
    "whitesmoke": "#f5f5f5",
    "yellow": "#ffff00",
    "yellowgreen": "#9acd32"
}
*/
